import axios from 'axios';

const asListResponse = (data: any) => {
  if (Array.isArray(data)) {
    return { hasError: false, records: data, errorMessages: [] };
  }
  if (data?.records) {
    return data;
  }
  return { hasError: false, records: data ? [data] : [], errorMessages: [] };
};

const authorizationAuditService = {
  list: (tenantId?: string) =>
    axios
      .get(`/api/authorization-audits/list`, {
        params: tenantId ? { tenantId } : undefined,
      })
      .then((response) => asListResponse(response.data)),
};

export default authorizationAuditService;
